import type { i18n } from 'i18next';

// localStorage key used to persist the user's selected UI language
export const languageKey = 'lngkey';

// Local test mode - set VITE_LOCAL_TEST_ENABLED='true' in .env to enable mock data
export const LOCAL_TEST_ENABLED = import.meta.env.VITE_LOCAL_TEST_ENABLED === 'true';

export const API_HOST = getEnv('VITE_API_HOST');
export const BASE_PATH = getEnv('VITE_BASE_PATH');
export const BING_API_KEY = getEnv('VITE_BING_API_KEY');
export const BING_AUTOSUGGEST_URL = getEnv('VITE_BING_AUTOSUGGEST_URL');
export const COOKIE_DOMAIN = getEnv('VITE_COOKIE_DOMAIN');
export const REDIRECT_URI = getEnv('VITE_REDIRECT_URI');
export const POST_LOGOUT_URI = getEnv('VITE_POST_LOGOUT_URI');
export const CLIENT_ID = getEnv('VITE_CLIENT_ID');
export const DOMAIN_URI = getEnv('VITE_DOMAIN_URI');
export const SIGN_UP_SIGN_IN_URI = getEnv('VITE_SIGN_UP_SIGN_IN_URI');
export const EDIT_PROFILE_URI = getEnv('VITE_EDIT_PROFILE_URI');
export const AFTERMARKET_CAMPAIGNS_SCOPE_URI = getEnv('VITE_AFTERMARKET_CAMPAIGNS_SCOPE_URI');
export const INDIVIDUAL_PRODUCTS_SCOPE_URI = getEnv('VITE_INDIVIDUAL_PRODUCTS_SCOPE_URI');
export const SERVICE_PROTOCOLS_SCOPE_URI = getEnv('VITE_SERVICE_PROTOCOLS_SCOPE_URI');
export const UNITS_SCOPE_URI = getEnv('VITE_UNITS_SCOPE_URI');
export const EXTERNAL_NATIVE_APPLICATIONS = [getEnv('VITE_EXTERNAL_IOS_ID'), getEnv('VITE_EXTERNAL_ANDROID_ID')];
export const FLEET_SCOPE_URI = getEnv('VITE_FLEET_SCOPE_URI');
export const UNIT_STATUSES_SCOPE_URI = getEnv('VITE_UNIT_STATUSES_SCOPE_URI');
export const SHOW_RSWDL_DEBUGGER = getEnv('VITE_SHOW_RSWDL_DEBUGGER');
export const FLEET_PRODUCTION_URI = getEnv('VITE_FLEET_PRODUCTION_URI');
export const POWER_SOLUTIONS_SCOPE_URI = getEnv('VITE_POWER_SOLUTIONS_SCOPE_URI');
export const CAMPAIGN_STATUSES_SCOPE_URI = getEnv('VITE_CAMPAIGN_STATUSES_SCOPE_URI');
export const SHORTRANGEBLE_SCOPE_URI = getEnv('VITE_SHORTRANGEBLE_SCOPE_URI');
export const NOTIFICATION_DEVICES_SCOPE_URI = getEnv('VITE_NOTIFICATION_DEVICES_SCOPE_URI');

export const USE_FLEET_PROD = FLEET_PRODUCTION_URI === 'true';
export const FLEET_REVERSE_PROXY_URI = `bdip/${USE_FLEET_PROD ? 'prod/' : ''}fleets-api/api/v1`;
export const CAMPAIGN_STATUS_REVERSE_PROXY_URI = `bdip/${USE_FLEET_PROD ? 'prod/' : ''}campaignstatus-api`;
export const SHORTRANGEBLE_REVERSE_PROXY_URI = `bdip/${USE_FLEET_PROD ? 'prod/' : ''}shortrangeble-api`;

const LANGUAGES = ['en', 'sv', 'de', 'fr', 'nl', 'it', 'pt'];

export const ECM_SCOPES = [
  AFTERMARKET_CAMPAIGNS_SCOPE_URI,
  INDIVIDUAL_PRODUCTS_SCOPE_URI,
  SERVICE_PROTOCOLS_SCOPE_URI,
  UNITS_SCOPE_URI,
  UNIT_STATUSES_SCOPE_URI,
  FLEET_SCOPE_URI,
  POWER_SOLUTIONS_SCOPE_URI,
  CAMPAIGN_STATUSES_SCOPE_URI,
  SHORTRANGEBLE_SCOPE_URI,
  NOTIFICATION_DEVICES_SCOPE_URI,
];

export const featuresName = {
  testFeatureToggle: 'testFeatureToggle',
  hideEasyConnectProvisioning: 'hideEasyConnectProvisioning',
};
const featuresTogglers: Map<string, boolean> = new Map();
featuresTogglers.set(featuresName.testFeatureToggle, true);
// Toggles hiding of Easy Connect (EC / EC_Wifi) digital-service provisioning eligibility
// in the units table, unit headers and the unit Services tab. Released to production with
// the Easy Connect relaunch (AB#1214109); set to true to hide EC provisioning again.
featuresTogglers.set(featuresName.hideEasyConnectProvisioning, false);

export function isFeatureToggled(key: string): boolean {
  return featuresTogglers.get(key) ?? false;
}

export const setLanguage = (lng: string, i18n: i18n) => {
  const language = LANGUAGES.includes(lng) ? lng : LANGUAGES[0];
  i18n.changeLanguage(language);
  document.documentElement.setAttribute('lang', language);
  localStorage.setItem(languageKey, language);
};

function getEnv(key: string): string {
  const envVar = import.meta.env[key];

  if (envVar === undefined) {
    throw new Error(`
      Missing environment variable \`${key}\`.

      You can set it in your \`.env.${import.meta.env.MODE}\` file.
    `);
  }
  return envVar;
}
